<div class="page">

  <div class="pagehead">
    <div>
      <h1>My plans</h1>
      <p>Your commission slabs and discounts, service by service</p>
    </div>
    <div class="filters">
      <div class="seg" role="tablist" aria-label="Service">
        <button type="button" [class.on]="activePlan === 'aeps'" (click)="activePlan = 'aeps'">AePS</button>
        <button type="button" [class.on]="activePlan === 'dmt'" (click)="activePlan = 'dmt'">DMT</button>
        <button type="button" [class.on]="activePlan === 'matm'" (click)="activePlan = 'matm'">mATM</button>
        <button type="button" [class.on]="activePlan === 'cms'" (click)="activePlan = 'cms'">CMS</button>
        <button type="button" [class.on]="activePlan === 'mobile'" (click)="activePlan = 'mobile'">Mobile</button>
        <button type="button" [class.on]="activePlan === 'dth'" (click)="activePlan = 'dth'">DTH</button>
      </div>
    </div>
  </div>

  <ng-container *ngIf="RetailerCommission; else planSkel">

    <!-- ============ AEPS (fixed slabs) ============ -->
    <div class="tbl-card" *ngIf="activePlan === 'aeps'">
      <div class="tbl-head"><h3>AePS · fixed slabs</h3></div>
      <div class="tbl-scroll">
        <table>
          <thead><tr><th>Range / service</th><th class="r">Commission</th></tr></thead>
          <tbody>
            <ng-container *ngFor="let range of RetailerCommission">
              <tr *ngIf="(range.serviceName=='AEPS' && range.subServiceName!='AADHARPAY_CASH_WITHDRAWL' && range.subServiceName=='AEPS_CASH_WITHDRAWAL')">
                <td class="svc">₹{{ range.startRange }} – {{ range.endRange }}</td>
                <td class="r">
                  <span class="amt" *ngIf="range.commissionvaluetype=='PERCENTAGE'">{{ range.retailorPercentage * range.totalCommissionPercentage / 100 }}<span class="unit">%</span></span>
                  <span class="amt" *ngIf="range.commissionvaluetype=='FIXED'"><span class="unit">₹</span>{{ range.retailorPercentage }}</span>
                </td>
              </tr>
            </ng-container>
            <ng-container *ngFor="let range of RetailerCommission">
              <tr *ngIf="(range.serviceName=='AEPS' && range.subServiceName=='AADHARPAY_CASH_WITHDRAWL')">
                <td class="svc">Aadhaar Pay</td>
                <td class="r">
                  <span class="amt" *ngIf="range.commissionvaluetype=='PERCENTAGE'">{{ range.retailorPercentage * range.totalCommissionPercentage / 100 }}<span class="unit">%</span></span>
                  <span class="amt" *ngIf="range.commissionvaluetype=='FIXED'"><span class="unit">₹</span>{{ range.retailorPercentage }}</span>
                </td>
              </tr>
            </ng-container>
            <ng-container *ngFor="let range of RetailerCommission">
              <tr *ngIf="(range.serviceName=='AEPS' && range.subServiceName=='AEPS_MINI_STATEMENT')">
                <td class="svc">Mini statement</td>
                <td class="r">
                  <span class="amt" *ngIf="range.commissionvaluetype=='PERCENTAGE'">{{ range.retailorPercentage * range.totalCommissionPercentage / 100 }}<span class="unit">%</span></span>
                  <span class="amt" *ngIf="range.commissionvaluetype=='FIXED'"><span class="unit">₹</span>{{ range.retailorPercentage }}</span>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
    </div>

    <!-- ============ DMT ============ -->
    <ng-container *ngIf="activePlan === 'dmt'">
      <div class="tbl-card stack">
        <div class="tbl-head"><h3>DMT · IMPS</h3></div>
        <div class="tbl-scroll">
          <table>
            <thead><tr><th>Range</th><th class="r">Service charge</th><th class="r">Commission</th></tr></thead>
            <tbody>
              <ng-container *ngFor="let range of RetailerCommission">
                <tr *ngIf="(range.serviceName=='DMT' && range.subServiceName=='DMT_IMPS')">
                  <td class="svc">₹{{ range.startRange }} – {{ range.endRange }}</td>
                  <td class="r">
                    <span *ngIf="range.commissionvaluetype=='PERCENTAGE'">{{ range.totalCommissionPercentage }}<span class="unit">%</span></span>
                    <span *ngIf="range.commissionvaluetype=='FIXED'"><span class="unit">₹</span>{{ range.totalCommissionPercentage }}</span>
                  </td>
                  <td class="r">
                    <span class="amt" *ngIf="range.commissionvaluetype=='PERCENTAGE'">{{ range.retailorPercentage * range.totalCommissionPercentage / 100 }}<span class="unit">%</span></span>
                    <span class="amt" *ngIf="range.commissionvaluetype=='FIXED'"><span class="unit">₹</span>{{ range.retailorPercentage }}</span>
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>
      </div>
      <div class="tbl-card stack">
        <div class="tbl-head"><h3>DMT · NEFT</h3></div>
        <div class="tbl-scroll">
          <table>
            <thead><tr><th>Range</th><th class="r">Service charge</th><th class="r">Commission</th></tr></thead>
            <tbody>
              <ng-container *ngFor="let range of RetailerCommission">
                <tr *ngIf="(range.serviceName=='DMT' && range.subServiceName=='DMT_NEFT')">
                  <td class="svc">₹{{ range.startRange }} – {{ range.endRange }}</td>
                  <td class="r">
                    <span *ngIf="range.commissionvaluetype=='PERCENTAGE'">{{ range.serviceCharge }}<span class="unit">%</span></span>
                    <span *ngIf="range.commissionvaluetype=='FIXED'"><span class="unit">₹</span>{{ range.serviceCharge }}</span>
                  </td>
                  <td class="r">
                    <span class="amt" *ngIf="range.commissionvaluetype=='PERCENTAGE'">{{ range.retailorPercentage * range.totalCommissionPercentage / 100 }}<span class="unit">%</span></span>
                    <span class="amt" *ngIf="range.commissionvaluetype=='FIXED'"><span class="unit">₹</span>{{ range.retailorPercentage }}</span>
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>
      </div>
    </ng-container>

    <!-- ============ mATM (fixed slabs) ============ -->
    <div class="tbl-card" *ngIf="activePlan === 'matm'">
      <div class="tbl-head"><h3>mATM · fixed slabs</h3></div>
      <div class="tbl-scroll">
        <table>
          <thead><tr><th>Range</th><th class="r">Commission</th></tr></thead>
          <tbody>
            <ng-container *ngFor="let range of RetailerCommission">
              <tr *ngIf="(range.serviceName=='MICRO_ATM' && range.subServiceName=='MICRO_ATM_CASH_WITHDRAWL')">
                <td class="svc">₹{{ range.startRange }} – {{ range.endRange }}</td>
                <td class="r">
                  <span class="amt" *ngIf="range.commissionvaluetype=='PERCENTAGE'">{{ range.retailorPercentage * range.totalCommissionPercentage / 100 }}<span class="unit">%</span></span>
                  <span class="amt" *ngIf="range.commissionvaluetype=='FIXED'"><span class="unit">₹</span>{{ range.retailorPercentage }}</span>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
    </div>

    <!-- ============ CMS ============ -->
    <div class="tbl-card" *ngIf="activePlan === 'cms'">
      <div class="tbl-head"><h3>CMS</h3></div>
      <div class="tbl-scroll">
        <table>
          <thead><tr><th>Range</th><th class="r">Commission</th></tr></thead>
          <tbody>
            <ng-container *ngFor="let range of RetailerCommission">
              <tr *ngIf="(range.serviceName=='CMS' && range.subServiceName=='CASH_MANAGEMENT_SERVICE')">
                <td class="svc">₹{{ range.startRange }} – {{ range.endRange }}</td>
                <td class="r">
                  <span class="amt" *ngIf="range.commissionvaluetype=='PERCENTAGE'">{{ range.retailorPercentage * range.totalCommissionPercentage / 100 | number:'1.2-2' }}<span class="unit">%</span></span>
                  <span class="amt" *ngIf="range.commissionvaluetype=='FIXED'"><span class="unit">₹</span>{{ range.retailorPercentage }}</span>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
    </div>

    <!-- ============ MOBILE ============ -->
    <ng-container *ngIf="activePlan === 'mobile'">
      <div class="tbl-card stack">
        <div class="tbl-head"><h3>Mobile · prepaid discount</h3></div>
        <div class="tbl-scroll">
          <table>
            <thead><tr><th>Operator</th><th class="r">Discount</th></tr></thead>
            <tbody>
              <ng-container *ngFor="let range of RetailerCommission">
                <tr *ngIf="(range.serviceName=='RECHARGE' && range.subServiceName=='RECHARGE_AIRTELM_PREPAID' && range.commissionvaluetype=='PERCENTAGE' && range.type=='DISCOUNT')">
                  <td><span class="op-chip"><img src="https://images.vartulz.com/airtel.png" alt="Airtel"></span></td>
                  <td class="r"><span class="amt">{{ range.retailorPercentage * range.discount / 100 | number:'1.2-2' }}<span class="unit">%</span></span></td>
                </tr>
                <tr *ngIf="(range.serviceName=='RECHARGE' && range.subServiceName=='RECHARGE_VIM_PREPAID' && range.commissionvaluetype=='PERCENTAGE' && range.type=='DISCOUNT')">
                  <td><span class="op-chip"><img src="https://images.vartulz.com/VI.png" alt="VI"></span></td>
                  <td class="r"><span class="amt">{{ range.retailorPercentage * range.discount / 100 | number:'1.2-2' }}<span class="unit">%</span></span> <span class="mono">({{ range.startRange }} – {{ range.endRange }})</span></td>
                </tr>
                <tr *ngIf="(range.serviceName=='RECHARGE' && range.subServiceName=='RECHARGE_BSNLM_PREPAID' && range.commissionvaluetype=='PERCENTAGE' && range.type=='DISCOUNT')">
                  <td><span class="op-chip"><img src="https://images.vartulz.com/BSNL.png" alt="BSNL"></span></td>
                  <td class="r"><span class="amt">{{ range.retailorPercentage * range.discount / 100 | number:'1.2-2' }}<span class="unit">%</span></span> <span class="mono">({{ range.startRange }} – {{ range.endRange }})</span></td>
                </tr>
                <tr *ngIf="(range.serviceName=='RECHARGE' && range.subServiceName=='RECHARGE_MTNLM_PREPAID' && range.commissionvaluetype=='PERCENTAGE' && range.type=='DISCOUNT')">
                  <td><span class="op-chip"><img src="https://images.vartulz.com/MTNL.png" alt="MTNL"></span></td>
                  <td class="r"><span class="amt">{{ range.retailorPercentage * range.discount / 100 | number:'1.2-2' }}<span class="unit">%</span></span> <span class="mono">({{ range.startRange }} – {{ range.endRange }})</span></td>
                </tr>
                <tr *ngIf="(range.serviceName=='RECHARGE' && range.subServiceName=='RECHARGE_JIOM_PREPAID' && range.commissionvaluetype=='PERCENTAGE' && range.type=='DISCOUNT')">
                  <td><span class="op-chip"><img src="https://images.vartulz.com/Jio.png" alt="Jio"></span></td>
                  <td class="r"><span class="amt">{{ range.retailorPercentage * range.discount / 100 | number:'1.2-2' }}<span class="unit">%</span></span></td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>
      </div>
      <div class="tbl-card stack">
        <div class="tbl-head"><h3>Mobile · postpaid commission</h3></div>
        <div class="tbl-scroll">
          <table>
            <thead><tr><th>Operator</th><th class="r">Commission</th></tr></thead>
            <tbody>
              <ng-container *ngFor="let range of RetailerCommission">
                <tr *ngIf="(range.serviceName=='RECHARGE' && range.subServiceName=='RECHARGE_AIRTELM_POSTPAID' && range.commissionvaluetype=='PERCENTAGE' && range.type=='COMMISSION')">
                  <td><span class="op-chip"><img src="https://images.vartulz.com/airtel.png" alt="Airtel"></span></td>
                  <td class="r"><span class="amt">{{ range.retailorPercentage * range.totalCommissionPercentage / 100 | number:'1.2-2' }}<span class="unit">%</span></span></td>
                </tr>
                <tr *ngIf="(range.serviceName=='RECHARGE' && range.subServiceName=='RECHARGE_VIM_POSTPAID' && range.commissionvaluetype=='PERCENTAGE' && range.type=='COMMISSION')">
                  <td><span class="op-chip"><img src="https://images.vartulz.com/VI.png" alt="VI"></span></td>
                  <td class="r"><span class="amt">{{ range.retailorPercentage * range.totalCommissionPercentage / 100 | number:'1.2-2' }}<span class="unit">%</span></span></td>
                </tr>
                <tr *ngIf="(range.serviceName=='RECHARGE' && range.subServiceName=='RECHARGE_BSNLM_POSTPAID' && range.commissionvaluetype=='PERCENTAGE' && range.type=='COMMISSION')">
                  <td><span class="op-chip"><img src="https://images.vartulz.com/BSNL.png" alt="BSNL"></span></td>
                  <td class="r"><span class="amt">{{ range.retailorPercentage * range.totalCommissionPercentage / 100 | number:'1.2-2' }}<span class="unit">%</span></span></td>
                </tr>
                <tr *ngIf="(range.serviceName=='RECHARGE' && range.subServiceName=='RECHARGE_MTNLM_POSTPAID' && range.commissionvaluetype=='PERCENTAGE' && range.type=='COMMISSION')">
                  <td><span class="op-chip"><img src="https://images.vartulz.com/MTNL.png" alt="MTNL"></span></td>
                  <td class="r"><span class="amt">{{ range.retailorPercentage * range.totalCommissionPercentage / 100 | number:'1.2-2' }}<span class="unit">%</span></span></td>
                </tr>
                <tr *ngIf="(range.serviceName=='RECHARGE' && range.subServiceName=='RECHARGE_JIOM_POSTPAID' && range.commissionvaluetype=='PERCENTAGE' && range.type=='COMMISSION')">
                  <td><span class="op-chip"><img src="https://images.vartulz.com/Jio.png" alt="Jio"></span></td>
                  <td class="r"><span class="amt">{{ range.retailorPercentage * range.totalCommissionPercentage / 100 | number:'1.2-2' }}<span class="unit">%</span></span></td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>
      </div>
    </ng-container>

    <!-- ============ DTH ============ -->
    <div class="tbl-card" *ngIf="activePlan === 'dth'">
      <div class="tbl-head"><h3>DTH · discount</h3></div>
      <div class="tbl-scroll">
        <table>
          <thead><tr><th>Operator</th><th class="r">Discount</th></tr></thead>
          <tbody>
            <ng-container *ngFor="let range of RetailerCommission">
              <tr *ngIf="(range.serviceName=='RECHARGE' && range.subServiceName=='RECHARGE_AIRTEL_DTH' && range.commissionvaluetype=='PERCENTAGE' && range.type=='DISCOUNT')">
                <td><span class="op-chip"><img src="https://images.vartulz.com/airtel.png" alt="Airtel Digital TV"></span></td>
                <td class="r"><span class="amt">{{ range.retailorPercentage * range.discount / 100 | number:'1.2-2' }}<span class="unit">%</span></span></td>
              </tr>
              <tr *ngIf="(range.serviceName=='RECHARGE' && range.subServiceName=='RECHARGE_DISH_DTH' && range.commissionvaluetype=='PERCENTAGE' && range.type=='DISCOUNT')">
                <td><span class="op-chip"><img src="https://images.vartulz.com/dish_tv.png" alt="Dish TV"></span></td>
                <td class="r"><span class="amt">{{ range.retailorPercentage * range.discount / 100 | number:'1.2-2' }}<span class="unit">%</span></span></td>
              </tr>
              <tr *ngIf="(range.serviceName=='RECHARGE' && range.subServiceName=='RECHARGE_SUN_DTH' && range.commissionvaluetype=='PERCENTAGE' && range.type=='DISCOUNT')">
                <td><span class="op-chip"><img src="https://images.vartulz.com/sundirect.jpg" alt="Sun Direct"></span></td>
                <td class="r"><span class="amt">{{ range.retailorPercentage * range.discount / 100 | number:'1.2-2' }}<span class="unit">%</span></span></td>
              </tr>
              <tr *ngIf="(range.serviceName=='RECHARGE' && range.subServiceName=='RECHARGE_TATASKY_DTH' && range.commissionvaluetype=='PERCENTAGE' && range.type=='DISCOUNT')">
                <td><span class="op-chip"><img src="https://images.vartulz.com/tata_sky.png" alt="Tata Play"></span></td>
                <td class="r"><span class="amt">{{ range.retailorPercentage * range.discount / 100 | number:'1.2-2' }}<span class="unit">%</span></span></td>
              </tr>
              <tr *ngIf="(range.serviceName=='RECHARGE' && range.subServiceName=='RECHARGE_VIDEOCON_DTH' && range.commissionvaluetype=='PERCENTAGE' && range.type=='DISCOUNT')">
                <td><span class="op-chip"><img src="https://images.vartulz.com/videocon.png" alt="Videocon d2h"></span></td>
                <td class="r"><span class="amt">{{ range.retailorPercentage * range.discount / 100 | number:'1.2-2' }}<span class="unit">%</span></span></td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
    </div>

  </ng-container>
  <ng-template #planSkel>
    <div class="tbl-card">
      <div class="er-skel er-skel--text" style="width:30%;margin:20px 22px 8px"></div>
      <div class="er-skel er-skel--text" style="margin:14px 22px" *ngFor="let i of [1,2,3,4,5]"></div>
    </div>
  </ng-template>

</div>
